import { render } from "./ViewUser.vue?vue&type=template&id=48d8408c&scoped=true"
import script from "./ViewUser.vue?vue&type=script&lang=js"
export * from "./ViewUser.vue?vue&type=script&lang=js"

import "./ViewUser.vue?vue&type=style&index=0&id=48d8408c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-48d8408c"

export default script